import { useAtomValue } from 'jotai';
import { useMatch } from 'react-router-dom';
import { playerMetricPercentilesAndBucketsAtom } from '@/atoms/queries/players';
import { teamMetricPercentilesAndBucketsAtom } from '@/atoms/queries/teams';

/**
 * Custom hook that selects the appropriate metric distribution atoms based on
 * whether we're in the player or team section of the app.
 *
 * @returns Object containing isPlayerSection flag and the metric distribution data
 */
export const useMetricDistributionAtoms = () => {
  const isPlayerSection = !!useMatch('/:locale/player/*');

  const metricPercentilesAndBucketsAtom = isPlayerSection
    ? playerMetricPercentilesAndBucketsAtom
    : teamMetricPercentilesAndBucketsAtom;
  const { percentiles, buckets } = useAtomValue(metricPercentilesAndBucketsAtom);

  return {
    isPlayerSection,
    percentiles,
    buckets,
  };
};
